

export interface PromptPreset {
  id: string;
  name: string;
  prompt: string;
}

export enum TaskStatus {
  IDLE = 'IDLE',
  GENERATING = 'GENERATING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR'
}

export interface GroundingUrl {
  title: string;
  uri: string;
}

export interface GenerationTask {
  id: string;
  sourceId?: string;
  presetName: string;
  status: TaskStatus;
  inputSummary: string;
  outputContent: string;
  groundingUrls?: GroundingUrl[];
  errorMessage?: string;
  createdAt: number;
  updatedAt?: number;
  articleTitle?: string;
  /** True when the local draft/title differs from the Firestore version (body/title edited). */
  hasLocalEdits?: boolean;
  isWeekend?: boolean;
  category?: string;
  isRegistered?: boolean;
  userId?: string;
  isContentInStorage?: boolean;
  articleUrl?: string;
  agentName?: string;
  daumPublishedAt?: number | null;
  fullHtml?: string;
  images?: string[];
  notionPageId?: string;
}

export interface Channel {
  id: string;
  name: string;
  description?: string;
  prompt?: string;
  notionDatabaseId?: string;
  createdAt: number;
  updatedAt?: number;
  userId?: string;
}

export interface UserPermission {
  id: string; // email
  email: string;
  allowedAgents: string[]; // ['all'] or specific agent names
  isAdmin: boolean;
  updatedAt: number;
}

export enum ViewMode {
  GENERATOR = 'GENERATOR',
  EDITOR = 'EDITOR',
  CHANNELS = 'CHANNELS',
  PERMISSIONS = 'PERMISSIONS'
}

export interface UploadedImage {
  base64: string;
  mimeType: string;
}
